import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { FC } from "react";

export const OtherIcon: FC = () => (
  <MoreHorizIcon style={{ pointerEvents: "none" }} />
);
